export default "__VITE_ASSET__Drbpxdnv__"